import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

// Inline status/notice block — the shadcn-era replacement for MUI's <Alert>.
// Carries the same announced semantics MUI gave for free: error/warning are
// assertive (role="alert"), success/info are polite (role="status").
const alertVariants = cva(
  "rounded-md border px-4 py-3 text-sm",
  {
    variants: {
      severity: {
        error: "border-red-200 bg-red-50 text-red-800",
        warning: "border-amber-200 bg-amber-50 text-amber-900",
        success: "border-green-200 bg-green-50 text-green-800",
        info: "border-blue-200 bg-blue-50 text-blue-800",
      },
    },
    defaultVariants: {
      severity: "info",
    },
  }
)

export interface AlertProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof alertVariants> {}

export function Alert({ className, severity, ...props }: AlertProps) {
  const role = severity === "error" || severity === "warning" ? "alert" : "status"
  return (
    <div role={role} className={cn(alertVariants({ severity }), className)} {...props} />
  )
}
